import API from "../../apiConfig";

export const sendBroadcast = async (data) => {
  const response = await API.post("/promotion/sendSms", data);
  return response;
};